import InspectionList from './InspectionList';

export default InspectionList;
